<template>
  <div class="footer">
    <div class="footer-column-a">
      <div class="f_row-link">
        <span class="link_desc">友情链接：</span>
        <div class="link_ul">
          <!-- <a
            v-for="(item, index) in FriendlyLinkList"
            :key="index"
            target="_blank"
            :href="item.linkUrl"
            :title="item.linkName"
          >
            {{ item.linkName }}
          </a> -->
          <a
            target="_blank"
            href="http://www.giihg.com/"
            title="广州工业投资控股集团有限公司"
          >
            广州工业投资控股集团有限公司
          </a>
          <a
            target="_blank"
            href="http://rsj.gz.gov.cn/"
            title="广州市人力资源和社会保障局"
          >
            广州市人力资源和社会保障局
          </a>
          <a
            target="_blank"
            href="https://gzast.org.cn/"
            title="广州市科学技术协会"
          >
            广州市科学技术协会
          </a>
          <a
            target="_blank"
            href="https://www.gcec.com.cn/"
            title="广州化工交易中心有限公司"
          >
            广州化工交易中心有限公司
          </a>
        </div>
      </div>
    </div>
    <div class="footer-column-b">
      <a
        class="fbeian_link"
        target="_blank"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        title="粤ICP备2022048838号"
      >
        广州市化工行业协会版权所有 ICP号：粤ICP备2022048838号
        技术支持：广州化工交易中心有限公司
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "ComFooter",
  data() {
    return {
      FriendlyLinkList: [],
    };
  },
  mounted() {
    this.getFriendlyLinkList();
  },
  methods: {
    async getFriendlyLinkList() {
      let _that = this;
      let res = await this.$request.getFriendlyLinkList();
      if (res.code == 200) {
        _that.FriendlyLinkList = res.rows;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #003b99;
.footer {
  width: 100%;
  background-color: $themeColor;
  position: relative;
  .footer-column-a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1180px;
    margin: 0 auto;
    padding: 20px 0 30px 0;

    .f_row-link {
      display: flex;
      font-size: 16px;
      color: #ffffff;
      padding: 30px 20px 0 20px;
      height: 30px;
      line-height: 30px;
      .link_desc {
        display: inline-block;
        width: 120px;
        text-align: right;
      }
      .link_ul {
        display: inline-block;
        // width: 960px;
      }
      a {
        height: 30px;
        line-height: 30px;
        display: inline-block;
        padding: 0 0 0 20px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .footer-column-b {
    width: 1180px;
    margin: 0 auto;
    padding: 30px 0;
    border-top: 1px solid #194ea3;
    .fbeian_link {
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
    }
  }
}
</style>
